import React, { ReactElement } from 'react';
import { Link } from '@mui/material';
import { RichTextJson } from '../types';

const formatAdvisoryMessageJson = (json: RichTextJson): (ReactElement | null)[]  => {
    if (!json.content) return [];

    return json.content
    .flatMap((paragraph) => paragraph.content)
    .map((node, index) => {
        if (node.nodeType === "text") {
            return <span key={index}>{node.value} </span>;
        } if (node.nodeType === "hyperlink") {
            const text = node.content?.[0]?.value || "";
            const uri = node.data?.uri || "#";
            return (
                <Link key={index} href={uri}>
                    {text}
                </Link>
            );
        }
        return null;
    });
}

export default formatAdvisoryMessageJson;